import React from 'react';
import { Row, Col, Space, Typography, Grid, Card, Divider } from 'antd';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Info() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      <Space direction='vertical' size={xs ? 16 : 64} style={{ marginTop: xs ? 8 : 32, width: '100%' }}>
        <Text style={{ fontSize: 15 }}>If your Abstract has been accepted either for oral or virtual category, you have to pay the relevant registration fees. Please note that one registration will cover only one presenter and/or one publication and one certificate. Furthermore, all Co-authors must register separately if they wish to attend the conference or to obtain certificates.</Text>
        
        <Row>
          <Col xs={{ span:24 }}  sm={{ span:20, offset:2 }} >
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, backgroundColor: '#E2E9E0' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text style={{ fontWeight: 'bold' }}>Category</Text>
                </Col>
                <Col span={8}>
                  <Text style={{ fontWeight: 'bold' }}>Early Bird</Text>
                </Col>
                <Col span={8}>
                  <Text style={{ fontWeight: 'bold' }}>Regular</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>Participant</Text>
                </Col>
                <Col span={8}>
                  <Text>-</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 150.005</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>Presenter Poster</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 200.005</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 350.005</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>Presenter Oral</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 300.005</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 500.005</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>International Publication (Atlantis)</Text>
                </Col>
                <Col span={8}>
                  <Text>-</Text>
                </Col>
                <Col span={8}>
                  <Text>Rp 2.850.005</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>Overseas Registrants</Text>
                </Col>
                <Col span={16}>
                  <Text>50 USD</Text>
                </Col>
              </Row>
            </Card>
            <Card style={{ textAlign: 'center', width: '100%', padding: 0, marginTop: 4, backgroundColor: '#F5F5F5' }} bodyStyle={{ padding: 8 }}>
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Text>International Publication (Atlantis) for Overseas Registrants</Text>
                </Col>
                <Col span={16}>
                  <Text>200 USD</Text>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Space direction="vertical" size={0}>
          <Text style={{ fontWeight: 'bold' }}>Note :</Text>
          <Text>1. Selected papers will be published in indexed international journals</Text>
          <Text>2. Registration fee does not include International Journal publication fees</Text>
        </Space>
      </Space>

      <Divider style={{ marginBottom: 16 }} />

      <Space direction="vertical" size={16}>
        <Text style={{ fontSize: xs ? 23 : 28, fontWeight: 'bold' }}>Timeline</Text>
        <Space direction="vertical" size={0}>
          <Text>• June 15 - September 15 abstract opened</Text>
          <Text>• July 1 - July 31 early bird</Text>
          <Text>• August 1 - October 20 regular</Text>
          <Text>• October 1 - November 30 full paper</Text>
        </Space>
      </Space>

      <Divider style={{ marginBottom: 16 }} />

      <Space direction='vertical' size={xs ? 16 : 32}>
        <Text style={{ fontSize: xs ? 23 : 28, fontWeight: 'bold' }}>Payment Method</Text>
        <Space direction="vertical" size={16}>
          <Text>Registration fee can be paid by wire transfer or credit card.</Text>
          <Space direction="vertical" size={0}>
            <Text>Wire transfer</Text>
            <Text>Bank Name: Bank Negara Indonesia (BNI)</Text>
            <Text>Account Number: <Text copyable>289127427</Text></Text>
            <Text>Account Name: Yayasan Binawan</Text>
            <Text>Swift code: <Text type='danger'>BNINIDJAXXX (only for foreign bank transfers)</Text></Text>
            <Text>Please add the number "5" for each payment code (example: 100.005)</Text>
          </Space>
        </Space>
      </Space>
    </React.Fragment>
  )
}

export default Info